import React from 'react';

class OptionsButton extends React.Component {
	render () {
		const { onClick, children, menuOnLeft, className = 'list-options' } = this.props;

		return (
			<ul className={ className }>
				<li>
					<div className="grid-x">
						{ menuOnLeft ? children : null }

						<div className="cell shrink">
							<button
								onClick={ onClick }
								className="button secondary clear margin-bottom-0 three-dot-menu-button">
									<span className="fi-braille icon"></span>
							</button>
						</div>

						{ menuOnLeft ? null : children }
					</div>
				</li>
			</ul>
		);
	}
}

export default OptionsButton;
